import { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { useCookies } from "./useCookies";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const location=useLocation()
  const [user, setUser] = useLocalStorage("user", null);
  const [cookie, setCookie] = useCookies("token", null);
  const navigate = useNavigate();

  const login = async (data) => {
    setUser(data);
    setCookie(data.token);
    localStorage.setItem('refresh',true)

    navigate("/", { replace: true });
  };
  const executiveLogin = async (data) => {
    setUser(data);
    setCookie(data.token);
    localStorage.setItem('refresh',true)
    navigate("/", { replace: true });
  };

  const logout = () => {
    setUser(null);
    setCookie(null);
    navigate("/login", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      executiveLogin,
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
